import { render, staticRenderFns } from "./VideoPreviewCard.vue?vue&type=template&id=46c4c139&"
import script from "./VideoPreviewCard.vue?vue&type=script&lang=js&"
export * from "./VideoPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoPreviewCard.vue?vue&type=style&index=0&id=46c4c139&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
